import React, {useEffect, useState} from 'react'
import WhiteArrowRight from '../../../media/felsv/white_right-arrow_icon.svg'
import DarkArrowLeft from '../../../media/felsv/dark_left-arrow_icon.svg'
import {bindActionCreators} from 'redux'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../reducers'
import {FormCreacionUsuario} from '../../../interfaces/creacionUsuario.interface'
import {
  actionCreacionUsuario,
  actionValidatorsCreacionUsuario,
} from '../../../actions/action-creators'
import {getDateOperacion} from '../../../utils/stringDate'
import {DICCIONARIO} from '../../../constants/Diccionario'
import {isNullOrEmpty} from '../../../utils/strings.utils'
import Help from '../../../components/DesignExterno/Help'

const InformacionCC = (props: any) => {
  const [disable, setDisable] = useState(true)
  const usuario: FormCreacionUsuario = useSelector((state: State) => state.creacionUsuario.formUser)
  const errors: FormCreacionUsuario = useSelector((state: State) => state.creacionUsuario.formError)
  const {tipoDocumento} = useSelector((state: State) => state.catalogos)
  const dispatch = useDispatch()

  const {creacionUsuarioFormHandleChange, creacionUsuarioHandleChange, creacionUsuario_guardarInformacion} = bindActionCreators(actionCreacionUsuario, dispatch)
  const validaciones = bindActionCreators(actionValidatorsCreacionUsuario, dispatch)
  const [originalEstateForm] = useState<FormCreacionUsuario>(usuario);

  useEffect(() => {
    if (
      usuario.birth_date &&
      usuario.first_name &&
      usuario.last_name &&
      // usuario.nit &&
      usuario.tipoDocumento &&
      usuario.id_number &&
      !errors.birth_date &&
      !errors.first_name &&
      !errors.last_name &&
      // !errors.nit &&
      !errors.tipoDocumento &&
      !errors.id_number &&
      // AGREGANDO LIMITANTES DE CAMPOS DE CARACTERES
      !errors.second_name &&
      !errors.third_name &&
      !errors.last_name2 &&
      !errors.last_name_married
    )
      setDisable(false)
    else setDisable(true)
  }, [usuario, errors])

  const submit = async (e: any) => {
    e.preventDefault()
    if (await validaciones.validacionesCreacionUsuarioFormInformacionSiguiente()) return
    if (await creacionUsuario_guardarInformacion()) {
      const keysActuales = Object.keys(usuario);
      for (const prop of keysActuales as Array<keyof FormCreacionUsuario>) {
        if (usuario[prop] !== originalEstateForm[prop]) {
          creacionUsuarioHandleChange({username: ""});
          break;
        }
      }
      props.next()
    }
  }
  
  const handleInput = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    creacionUsuarioFormHandleChange(event)
    validaciones.validacionesCreacionUsuarioOnBlurInformacion(event)
  }


  return (
    <form
      className='form-content'
      data-wf-page-id='64af1c9680a05070de3c97df'
      data-wf-element-id='ac417b8a-12e2-2eb3-27e8-231ec1120128'
      onSubmit={submit}
    >
      <div>
        <label htmlFor='birth_date' className='field-label m'>
          {DICCIONARIO.FECHA_NACIMIENTO}
          <span style={{color: 'red'}}>*</span>
        </label>
        <input
          autoComplete='off'
          autoFocus={true}
          type='date'
          className='m text-field w-input'
          maxLength={10}
          name='birth_date'
          data-name='birth_date'
          placeholder={DICCIONARIO.FECHA_NACIMIENTO}
          id='birth_date'
          min={getDateOperacion(-150)}
          max={getDateOperacion(-18)}
          value={usuario.birth_date}
          onChange={handleInput}
          onBlur={validaciones.validacionesCreacionUsuarioOnBlurInformacion}
        />
        {errors.birth_date && <p className='alert s'>{errors.birth_date}</p>}
      </div>
      <div className='w-layout-hflex h-inputs'>
        <div>
          <label htmlFor='first_name' className='field-label m'>
            {DICCIONARIO.PRIMER_NOMBRE}
            <span style={{color: 'red'}}>*</span>
          </label>
          <input
            autoComplete='off'
            type='text'
            className='m text-field w-input'
            maxLength={15}
            name='first_name'
            data-name='first_name'
            placeholder={DICCIONARIO.PRIMER_NOMBRE}
            id='first_name'
            value={usuario.first_name}
            onChange={handleInput}
            onBlur={validaciones.validacionesCreacionUsuarioOnBlurInformacion}
          />
          {errors.first_name && <p className='alert s'>{errors.first_name}</p>}
        </div>
        <div>
          <label htmlFor='second_name' className='field-label m'>
            {DICCIONARIO.SEGUNDO_NOMBRE}
          </label>
          <input
            autoComplete='off'
            type='text'
            className='m text-field w-input'
            maxLength={15}
            name='second_name'
            data-name='second_name'
            placeholder={DICCIONARIO.SEGUNDO_NOMBRE}
            id='second_name'
            value={usuario.second_name}
            onChange={handleInput}
            onBlur={validaciones.validacionesCreacionUsuarioOnBlurInformacion}
          />
          {errors.second_name && <p className='alert s'>{errors.second_name}</p>}
        </div>
      </div>
      <div className='w-layout-hflex h-inputs'>
        <div>
          <label htmlFor='third_name' className='field-label m'>
            {DICCIONARIO.TERCER_NOMBRE}
          </label>
          <input
            autoComplete='off'
            type='text'
            className='m text-field w-input'
            maxLength={15}
            name='third_name'
            data-name='third_name'
            placeholder={DICCIONARIO.TERCER_NOMBRE}
            id='third_name'
            value={usuario.third_name}
            onChange={handleInput}
            onBlur={validaciones.validacionesCreacionUsuarioOnBlurInformacion}
          />
          {errors.third_name && <p className='alert s'>{errors.third_name}</p>}
        </div>
        <div>
          <label htmlFor='last_name' className='field-label m'>
            {DICCIONARIO.PRIMER_APELLIDO}
            <span style={{color: 'red'}}>*</span>
          </label>
          <input
            autoComplete='off'
            type='text'
            className='m text-field w-input'
            maxLength={15}
            name='last_name'
            data-name='last_name'
            placeholder={DICCIONARIO.PRIMER_APELLIDO}
            id='last_name'
            value={usuario.last_name}
            onChange={handleInput}
            onBlur={validaciones.validacionesCreacionUsuarioOnBlurInformacion}
          />
          {errors.last_name && <p className='alert s'>{errors.last_name}</p>}
        </div>
      </div>
      <div className='w-layout-hflex h-inputs'>
        <div>
          <label htmlFor='last_name2' className='field-label m'>
            {DICCIONARIO.SEGUNDO_APELLIDO}
          </label>
          <input
            autoComplete='off'
            type='text'
            className='m text-field w-input'
            maxLength={15}
            name='last_name2'
            data-name='last_name2'
            placeholder={DICCIONARIO.SEGUNDO_APELLIDO}
            id='last_name2'
            value={usuario.last_name2}
            onChange={handleInput}
            onBlur={validaciones.validacionesCreacionUsuarioOnBlurInformacion}
          />
          {errors.last_name2 && <p className='alert s'>{errors.last_name2}</p>}
        </div>
        <div>
          <label htmlFor='last_name_married' className='field-label m'>
            {DICCIONARIO.APELLIDO_CASADA}
          </label>
          <input
            autoComplete='off'
            type='text'
            className='m text-field w-input'
            maxLength={15}
            name='last_name_married'
            data-name='last_name_married'
            placeholder={DICCIONARIO.APELLIDO_CASADA}
            id='last_name_married'
            value={usuario.last_name_married}
            onChange={handleInput}
            onBlur={validaciones.validacionesCreacionUsuarioOnBlurInformacion}
          />
          {errors.last_name_married && <p className='alert s'>{errors.last_name_married}</p>}
        </div>
      </div>
      <div>
        <label htmlFor='tipoDocumento' className='field-label m' style={{display: 'flex'}}>
          {DICCIONARIO.TIPO_DOCUMENTO_IDENTIFICACION}
          <span style={{color: 'red'}}>*</span>
          <Help simpleMessage={null} modalTitle='' helpImage={null} id_message='tipo_id'/>
        </label>
        <select
          id='tipoDocumento'
          name='tipoDocumento'
          data-name=''
          className='m text-field w-select'
          disabled={tipoDocumento.length === 0}
          value={usuario.tipoDocumento}
          onChange={handleInput}
          onBlur={validaciones.validacionesCreacionUsuarioOnBlurInformacion}
          style={{textTransform: 'uppercase'}}
        >
          <option value='' disabled>
            Selecciona una opción
          </option>
          {tipoDocumento.map((tipo) => (
            <option value={tipo?.codigo} key={tipo?.codigo}>
              {tipo?.valor}
            </option>
          ))}
        </select>
        {errors.tipoDocumento && <p className='alert s'>{errors.tipoDocumento}</p>}
      </div>
      <div>
        <label htmlFor='id_number' className='field-label m'>
          {usuario.nombreTipoDocumento || DICCIONARIO.NUMERO_DOCUMENTO_IDENTIFICACION}
          <span style={{color: 'red'}}>*</span>
        </label>
        <div style={{maxWidth: 380, fontSize: 11}} className='alert-info-text'>
          {
            (usuario.nombreTipoDocumento === 'NIT') &&
            'Ingresa tu número de identificación sin guiones.'  
          }
          {
            (usuario.nombreTipoDocumento === 'DUI') &&
            'Ingresa tu DUI sin guiones.'
          }
        </div>
        <input
          autoComplete='off'
          type='text'
          className='m text-field w-input'
          maxLength={14}
          name='id_number'
          data-name='id_number'
          placeholder={usuario.nombreTipoDocumento || DICCIONARIO.NUMERO_DOCUMENTO_IDENTIFICACION}
          id='id_number'
          disabled={isNullOrEmpty(usuario.tipoDocumento)}
          value={usuario.id_number}
          onChange={handleInput}
          onBlur={validaciones.validacionesCreacionUsuarioOnBlurInformacion}
        />
        {errors.id_number && <p className='alert s'>{errors.id_number}</p>}
      </div>
      <div className='w-layout-hflex button-actions' style={{marginBottom: '5%'}}>
        <button type='button' className='m button transparent w-inline-block' onClick={props.prev}>
          <img src={DarkArrowLeft} loading='lazy' alt='Regresar' />
          Regresar
        </button>
        <button type='submit' className='m button w-inline-block' disabled={disable}>
          Siguiente
          <img src={WhiteArrowRight} loading='lazy' alt='Siguiente' />
        </button>
      </div>
    </form>
  )
}

export default InformacionCC
